import { OptionTemplate } from "shared/api/middleware-api-client";
import { ZakelijkDiscountDetails } from "./ZakelijkDiscountDetails";

export const ConfigurationPricingTotalFooter = ({
  selectedDoor,
}: {
  selectedDoor: OptionTemplate | null;
}) => {
  return (
    <div className="gg-flex gg-max-w-[150px] gg-place-items-center sm:gg-max-w-full">
      <div className="gg-flex gg-flex-col gg-gap-x-1.5 lg:gg-grid lg:gg-grid-cols-2 lg:gg-gap-x-0">
        <div className="gg-mb-1 gg-flex gg-text-base gg-font-semibold gg-text-dark-blue/80 sm:gg-text-lg lg:gg-mb-0 lg:gg-items-center lg:gg-justify-center lg:gg-text-[22px]">
          Totaal
        </div>
        <ZakelijkDiscountDetails selectedDoor={selectedDoor} />
      </div>
    </div>
  );
};
